<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  question: {
    id: string;
    title: string;
    answers: [string, string, string?, string?, boolean?][];
  };
  selected: string[];
}>();
</script>

<template>
  <div class="tpl-htk__question">
    <h2 class="tpl-htk__question-title">{{ question.title }}</h2>
    <div class="tpl-htk__answers">
      <button
        v-for="answer in question.answers"
        :key="answer[0]"
        type="button"
        class="tpl-htk__answer"
        :class="{ 'tpl-htk__answer--selected': selected.includes(answer[0]) }"
        @click="$emit('answer', answer)"
      >
        <span class="tpl-htk__radio" aria-hidden="true"></span>
        <span v-if="answer[2]" class="tpl-htk__answer-icon" :style="{ color: answer[3] || undefined }">
          <font-awesome-icon :icon="answer[2]" />
        </span>
        <span class="tpl-htk__answer-text">{{ String(answer[1]) }}</span>
      </button>
    </div>
  </div>
</template>
